/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

export const fontFamilys = {
  poppinsFont: 'Poppins'
};

export const EllipsisText = styled.div`
  width: ${(props) => props.width || '150px'};
  text-overflow: ellipsis;
  overflow: hidden;
  text-wrap: nowrap;
`;
export const HeadingText = styled.div`
  font-size: 20px;
  font-weight: 600;
`;

export const FlexWrapper = styled.div`
  width: ${(props) => props.width};
  display: flex;
  flex-wrap: ${(props) => props.wrap || 'wrap'};
  flex-direction: ${(props) => props.direction || 'row'};
  justify-content: ${(props) => props.justify || 'center'};
  align-items: ${(props) => props.align || 'center'};
  gap: ${(props) => props.gap || '0px'};
  cursor: ${(props) => props.cursor || 'auto'};
  margin: ${(props) => props.margin || '0px'};

  .hms-remark {
    align-items: center;
    justify-content: space-between !important;
    width: 100%;
  }
`;

export const FlexWrapperNoData = styled.div`
  width: ${(props) => props.width};
  display: flex;
  flex-wrap: ${(props) => props.wrap || 'wrap'};
  flex-direction: ${(props) => props.direction || 'column'};
  justify-content: ${(props) => props.justify || 'center'};
  align-items: ${(props) => props.align || 'center'};
  gap: ${(props) => props.gap || '10px'};
  cursor: ${(props) => props.cursor || 'auto'};
  margin: ${(props) => props.margin || '0px'};
`;

export const FlexWrapperParent = styled.div`
  width: ${(props) => props.width};
  display: flex;
  flex-wrap: ${(props) => props.wrap || 'nowrap'};
  flex-direction: ${(props) => props.direction || 'row'};
  justify-content: ${(props) => props.justify || 'center'};
  align-items: ${(props) => props.align || 'center'};
  gap: ${(props) => props.gap || '10px'};
  cursor: ${(props) => props.cursor || 'auto'};
  margin: ${(props) => props.margin || '0px'};

  @media (max-width: 768px) {
    width: 100%;
    flex-wrap: wrap;
    justify-content: start;
  }

  @media (max-width: 568px) {
    width: 100%;
    align-items: start;
    justify-content: start;
    flex-direction: column-reverse;
  }

  .hms-remark {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .responsive-input {
    width: 280px;
  }

  @media (max-width: 620px) {
    .responsive-input {
      width: 100%;
    }
  }
  .responsive-select {
    width: 280px;
    margin-bottom: 10px;
  }

  @media (max-width: 620px) {
    .responsive-select {
      width: 100%;
    }
  }
`;
export const HeadingTable = styled.p`
  color: '#767676';
  margin: 0;
  display: flex;
  justify-content: start;
  width: 100%;
`;
export const TitleBox = styled.h4`
  color: rgba(0, 0, 0, 0.88);
  font-weight: 600;
  font-size: 20px;
  display: flex;
  justify-content: start;
  width: 100%;
  margin: 5px 0;
  padding: 0;
`;
export const LinkStyled = styled(Link)(({ display }) => ({
  textDecoration: 'none',
  color: 'inherit',
  display: display && display
}));

export const PaginationBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const ViewIconBox = styled.div`
  display: flex;
  width: 30px;
  height: 30px;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.primaryColor};
  border-radius: 50%;
  cursor: pointer;
`;
export const DeleteIconBox = styled.div`
  display: flex;
  width: 30px;
  height: 30px;
  justify-content: center;
  align-items: center;
  background: ${({ canDelete }) => (!canDelete ? '#cecece' : '#fb4a49')};
  cursor: ${({ canDelete }) => (!canDelete ? 'not-allowed' : 'pointer')};
  border-radius: 50%;
`;

export const UpdateKeyIconBox = styled.div`
  display: flex;
  width: 30px;
  height: 30px;
  justify-content: center;
  align-items: center;
  background: ${({ canUpdate }) => (!canUpdate ? '#cecece' : '#5F3A6B')};
  cursor: ${({ canUpdate }) => (!canUpdate ? 'not-allowed' : 'pointer')};
  border-radius: 50%;
`;

export const EditIconBox = styled.div`
  display: flex;
  width: 30px;
  height: 30px;
  justify-content: center;
  align-items: center;
  background: ${({ canUpdate }) => (!canUpdate ? '#cecece' : '#65beee')};
  cursor: ${({ canUpdate }) => (!canUpdate ? 'not-allowed' : 'pointer')};
  border-radius: 50%;
`;

export const PurpleText = styled.p`
  color: ${({ theme }) => theme.primaryColor};
  font-size: ${({ size }) => size || '14px'};
  margin: 0;
  font-family: Plus Jakarta Sans;
  font-weight: 500;
  text-align: ${({ align }) => align || 'start'};
  width: 100%;
`;

export const SkyText = styled.p`
  color: #65beee;
  font-size: ${({ size }) => size || '14px'};
  margin: 0;
  font-weight: 500;
  font-family: Plus Jakarta Sans;
`;

export const GreyText = styled.p`
  color: ${({ color }) => color || '#9f9f9f !important'};
  font-size: ${({ size }) => size || '12px'};
  margin: ${({ margin }) => margin || '0'};
  font-family: Plus Jakarta Sans;
  text-wrap: wrap;
`;

export const DarkText = styled.p`
  color: #0e0e0e !important;
  font-size: ${({ size }) => size || '14px'};
  font-weight: ${({ weight }) => weight || '500'};
  margin: ${({ margin }) => margin || '0'};
  font-family: Plus Jakarta Sans;
`;

export const Title = styled.h2`
  font-family: 'Plus Jakarta Sans';
  margin: 0;
  font-weight: 700;
  font-size: 20px;
  text-transform: capitalize;
`;

export const ApplyDate = styled.div`
  font-family: 'Plus Jakarta Sans';
  color: ${({ theme }) => theme.primaryColor};
  font-size: 14px;
  font-weight: 500;
  text-align: start;
`;
export const CardContent = styled.div`
  font-size: 16px;
  margin: 0px !important;
  color: '#7A7B7A';
  @media (max-width: 600px) {
    font-size: 12px;
  }
`;

export const FieldBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 10px;

  .addition-div {
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
      margin: 0px;
      color: ${({ theme }) => theme.primaryColor};
      cursor: pointer;
    }
  }

  * {
    margin-bottom: 0px !important;
  }

  label {
    span {
      color: red;
    }
  }
`;

export const GridBox = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ cols }) => `repeat(${cols}, 1fr)`};
  gap: ${({ gap }) => gap || '16px'};
`;

export const InfoWrapper = styled(FlexWrapper)`
  flex-direction: column;
  align-items: start;
  justify-content: start;
  gap: ${({ gap }) => gap || '4px'};
  text-align: left;

  span {
    font-size: 14px !important;
    font-weight: 500;
    color: #9f9f9f !important;
    margin: 0 !important;
    font-family: Plus Jakarta Sans !important;
  }

  p {
    font-size: 16px !important;
    font-weight: 500;
    color: #0e0e0e !important;
    margin: 0 !important;
    font-family: Plus Jakarta Sans !important;
  }
`;

export const DrawerStyle = styled.div`
  padding: 35px;
  height: 100%;
  overflow-y: auto;

  .loader {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .page-loader {
    height: 70px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  p {
    margin: 0;
  }
  .flexbox {
    display: flex;
    justify-content: space-between;

    .date {
      font-family: 'Plus Jakarta Sans';
      font-weight: 700;
      font-size: 16px;
      color: #0e0e0e;
    }
  }
  .custom-content {
    padding-bottom: 20px;
  }
  .action {
    font-size: 16px;

    .title {
      color: #000000;
      font-family: Poppins;
      font-weight: 600;
      font-size: 14px;
    }
  }
  .dotIcon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${({ theme }) => theme.primaryColor};
    rotate: -90deg;
  }
  .profile-flex {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 2px;
    margin-bottom: 8px;

    img {
      width: 16px;
      height: 16px;
      border-radius: 50%;
    }
  }
`;

export const ClickWrapper = styled.button`
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  @media (max-width: 600px) {
    padding: 0px 10px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 24px;
  gap: 12px;

  .reset {
    width: 100%;
    border-radius: 10px;
    border: 1px solid #0e0e0e;
    color: #0e0e0e;
    background: transparent;
    cursor: pointer;
    font-family: 'Plus Jakarta Sans';
    font-weight: 500;
    font-size: 14px;
  }
`;

// Lms and request detail pages

export const LeaveContainer = styled.div`
  background: #ffffff;
  padding: 24px;
  border-radius: 12px;
  margin: 0 auto;
  width: 100%;
  font-family: 'Plus Jakarta Sans';
`;

export const LeaveHeader = styled.div`
  font-family: 'Plus Jakarta Sans';
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column-reverse;
    align-items: start;
    gap: 15px;
  }
`;

export const LeaveLabel = styled.div`
  font-family: 'Plus Jakarta Sans';
  font-size: 14px;
  font-weight: 500;
  text-transform: capitalize;
`;

export const LeaveFooter = styled.div`
  font-family: 'Plus Jakarta Sans';
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;

export const CopyWrapper = styled(FlexWrapper)`
  justify-content: start !important;
  gap: 6px;
`;

export const HighlightText = styled.span`
  cursor: pointer;
  :hover {
    font-weight: 400;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryColor};
    text-decoration: underline;
  }
`;

export const SeeMore = styled.div`
  font-family: Plus Jakarta Sans;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 16px;
  color: ${({ theme }) => theme.primaryColor};
  text-align: start;
  cursor: pointer;

  :hover {
    text-decoration: underline;
  }
`;
export const BoxButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  @media (max-width: 668px) {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
`;
export const BoxEnd = styled.div`
  @media (max-width: 668px) {
    width: 100%;
    display: flex;
    justify-content: end;
    align-items: end;
    gap: 10px;
  }
`;

export const CloseBtn = styled.div`
  position: absolute;
  right: -10px;
  top: -10px;
  padding-bottom: 2px;
  background-color: var(--primary-color);
  border-radius: 50%;
  color: white;
  height: 27px;
  width: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  line-height: 32px;
  text-transform: none;
  text-rendering: auto;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: scale(1.2);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
`;

export const GrapBox = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  &::-webkit-scrollbar {
    height: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #e6e5e5ff;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .chart-wrapper {
    min-width: ${(props) => props.width || '100%'};
  }

  @media (max-width: ${(props) => props.breakpoint || '768px'}) {
  }
`;

export const TitleH4 = styled.h4`
  font-size: 20px;
  font-weight: 600;
  margin: 0px;
  color: #0e0e0e;
`;
export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-content: space-between;
  margin-bottom: 10px;

  @media (max-width: 380px) {
    flex-direction: column;
    gap: 5px;
    justify-content: start;
    align-items: start;
  }
`;
